export default {
  type: "string",
  description: "Same as redirect URI from first step",
  example: "CHANGE THIS"
};
